export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'category',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'channel',
    actions: {
      read: true,
    },
  },
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'calendar-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'media-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'teaser',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['youniverseStageAssets', 'youniverseScreenAssets'],
  },
  {
    for: 'story',
    actions: {
      read: true,
    },
  },
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'url-alias',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'mlp',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
];
